/* eslint-disable no-unused-vars */
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../state/configureStore'

type Resource = {
	resourceId: number
	resourceCode: string
	resourceDescription: string
	resourcePath: string
	view: boolean
}

type ResourcePathCodes = Record<string, string[]>

const getResourcePathCodes = (resources: Resource[], whiteList: string[]): ResourcePathCodes => {
	return resources.reduce(
		(acc, resource) => {
			const { resourcePath, resourceCode } = resource
			acc[resourcePath] = acc[resourcePath] || []
			if (!acc[resourcePath].includes(resourceCode)) {
				acc[resourcePath].push(resourceCode)
			}
			return acc
		},
		whiteList.reduce((acc, route) => {
			acc[route] = ['DF']
			return acc
		}, {} as ResourcePathCodes)
	)
}

export const useHasRoutePermission = ({ route }: { route: string }) => {
	const { permit } = useSelector((state: RootState) => state.session || {})
	const whiteList = [
		'/asistente-de-salud',
		'/completar-datos',
		'/informacion-diaria',
		'/servicios',
		'/herramientas',
		'/formacion-cuidador',
		'/tienda-del-cuidado',
		'/calcular-imc',
		'/cuestionario-vida',
		'/agregar-paciente',
		'/red-de-cuidado',
		'/habitos',
		'/envivos',
		'/aliados',
		'/centros-de-cuidado',
		'/terminos-y-condiciones',
		'/mi-rutina',
		'/mis-servicios',
		'/informacion-inicial',
		'/tus-servicios',
		'/califica'
	]

	const transformedResources = useMemo(
		() => getResourcePathCodes(permit?.resources || [], whiteList),
		[permit?.resources, whiteList]
	)

	const partialRoute = '/' + route.split('/')[1]

	return partialRoute in transformedResources
}

export const useHasPermission = ({ code }: { code: any }) => {
	const { permit } = useSelector((state: any) => state.session || {})

	const codesResources = permit?.resources?.map((resource: any) => resource.resourceCode)

	const resources: any = codesResources?.length > 0 ? [...codesResources, 'DF'] : []

	return resources?.includes(code)
}
